import EmptyColumns from "./EmptyColumns";

export default EmptyColumns;
